<hlm-dialog-header class="mb-6">
  <h3 hlmDialogTitle>{{ 'step_mode.failure_mode.missing_dialog.title' | translate }}</h3>
  <p hlmDialogDescription>
    {{ 'step_mode.failure_mode.missing_dialog.description' | translate }}
  </p>
</hlm-dialog-header>

<form
  class="flex min-h-0 w-full min-w-0 max-w-full flex-col gap-6"
  [formGroup]="form"
  (ngSubmit)="submitForm()"
>
  <hlm-form-field>
    <label hlmLabel for="fm_not_listed_comment">
      {{ 'step_mode.failure_mode.missing_dialog.label' | translate }}
      <span class="text-destructive">*</span>
    </label>
    <textarea
      hlmInput
      id="fm_not_listed_comment"
      formControlName="comment"
      rows="4"
      class="min-h-24 w-full"
      [placeholder]="'step_mode.failure_mode.missing_dialog.placeholder' | translate"
    ></textarea>
    @if (form.controls.comment.touched && form.controls.comment.invalid) {
      <hlm-error>{{ 'step_mode.failure_mode.missing_dialog.error' | translate }}</hlm-error>
    }
  </hlm-form-field>

  <div class="flex justify-end gap-2">
    <button hlmBtn type="button" variant="outline" [disabled]="isLoading()" (click)="cancel()">
      {{ 'buttons.cancel' | translate }}
    </button>
    <button hlmBtn type="submit" [disabled]="form.invalid || isLoading()">
      {{ 'step_mode.failure_mode.missing_dialog.submit' | translate }}
    </button>
  </div>
</form>
